import { z } from 'zod';
export { resolveLocalizedText } from './localized-text.js';
export function createLocalizedTextSchema(maxLength) {
    const text = z.string().trim().max(maxLength).optional();
    return z.object({ ar: text, en: text, de: text, nl: text }).strict();
}
//# sourceMappingURL=merchant-content.js.map